import { partial } from '../../utils/utils';
import { parseFolders } from './parsers/folders';
import { toError } from './parsers/error';
export function initFolders(settings, http) {
  function list(folderId, options) {
    if (folderId) {
      // Facebook doesn't have folders inside folders, so we can omit requesting server and return resolved promise right away
      return Promise.resolve({
        data: []
      });
    }
    options = options || {};
    options.paging = options.paging || {};
    const requestOptions = {
      limit: options.paging.size || settings.foldersLimit,
      after: options.paging.cursor || null
    };
    return http.get(`${settings.apiUrl}${settings.apiPath}/albums`, requestOptions, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(partial(parseFolders, settings)).catch(toError);
  }
  return {
    list
  };
}